var render, staticRenderFns
import script from "./BaseThumbnailButton.vue?vue&type=script&lang=ts&"
export * from "./BaseThumbnailButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseThumbnailButton.vue?vue&type=style&index=0&id=2c7d2bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d2bbd",
  null
  
)

export default component.exports